import { render, staticRenderFns } from "./ListRegisterRequests.vue?vue&type=template&id=52d52b00&scoped=true&"
import script from "./ListRegisterRequests.vue?vue&type=script&lang=js&"
export * from "./ListRegisterRequests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d52b00",
  null
  
)

export default component.exports